import { FC } from 'react';
import intl from 'react-intl-universal';
import { Tooltip } from '@getsynapse/design-system';
import EnableAccountToggleSwitch from './EnableAccountToggleSwitch';

interface EnableAccountToggleProps {
  isAccountEnabled: boolean;
  handleEnableDisable: () => Promise<void>;
  toggleDisabled: boolean;
}

const EnableAccountToggle: FC<EnableAccountToggleProps> = ({
  isAccountEnabled,
  handleEnableDisable,
  toggleDisabled,
}) => {
  if (toggleDisabled) {
    return (
      <Tooltip
        openMode='hover2'
        ariaId='license-info'
        position='bottomLeft'
        trigger={
          <div>
            <EnableAccountToggleSwitch
              isAccountEnabled={isAccountEnabled}
              handleEnableDisable={handleEnableDisable}
              toggleDisabled={toggleDisabled}
            />
          </div>
        }
        contentProps={{
          className: 'bg-warning-lighter text-warning-dark',
        }}
      >
        <span>{intl.get('LICENSE.LICENSE_ACTIVATION')}</span>
      </Tooltip>
    );
  }

  return (
    <EnableAccountToggleSwitch
      isAccountEnabled={isAccountEnabled}
      handleEnableDisable={handleEnableDisable}
      toggleDisabled={toggleDisabled}
    />
  );
};

export default EnableAccountToggle;
